<template>
    <div class="order">
        <div class="order-header flex align-cen">
              <div class="header-container-left" @click="openGo">
                 <img src="../../assets/images/HeroopSys.png" alt="" class="sider-logo">
            </div>
               <div class="header-container-con"></div> 
            <div class="header-container-right mft" style="margin-right:24px">
                <el-dropdown>
                <span class="el-dropdown-link flex align-cen" style="color:#fff;cursor: pointer;">
                  <img :src="user.avatar || require('../../assets/images/head.png')" alt="" class="sider-logo">
                 {{user.name}} <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="openMan"><i class="icon-al-laptop"></i> 进入后台</el-dropdown-item>
                     <el-dropdown-item @click.native="openSet"><i class="icon-al-cog"></i> 账号设置</el-dropdown-item>
                     <!-- <el-dropdown-item  @click.native="openOrder"><i class="icon-al-file"></i> 订单管理</el-dropdown-item> -->
                    <!-- <el-dropdown-item  ><i class="icon-al-poweroff"></i>退出登录</el-dropdown-item> -->
                </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <!-- pc订单列表 -->
        <div class="order-scne">
            <div class="order-y-row">
                <div class="order-notice-box">
                    <div class="order-notice-title">
                        <h2>企业订单</h2>
                    </div>
                    <div v-if="list.length ">
                   <div class="order-list"
                   v-for="(item, index) in list" :key="index"
                   >
                     <div class="list-header flex align-cen">
                        <span>订单号： {{item.id}}</span>
                        <span class="y-right mft">订单时间：{{item.createTime}}</span>
                    </div>
                    <div class="list-tab">
                        <div class="list-tit list-tit1 flex align-cen">
                            <div style="width:12.5%">订单类型</div>
                             <div style="width:20%">产品</div>
                             <div style="width:30%">订单主体</div>
                             <div style="width:12.5%">有效时间</div>
                              <div style="width:12.5%">订单来源</div>
                              <div style="width:12.5%">订单状态</div>
                        </div>
                         <div class="list-tit flex align-cen">
                            <div style="width:12.5%">{{item.orderType == 1 ? '应用订单' : item.orderType == 2 ? '课程订单' : '其他'}}</div>
                             <div style="width:20%">{{item.appName}}</div>
                             <div style="width:30%">{{item.businessName}}</div>
                             <div style="width:12.5%">{{item.deadline ? item.deadline + '月' : '无限期'}}</div>
                              <div style="width:12.5%">{{item.orderSource == 1 ? '官网' : '其他'}}</div>
                              <div style="width:12.5%">
                                {{item.orderStatus == 0 ? '已取消' :  item.orderStatus == 1 ? '待支付' : '已完成'}}
                              </div>
                        </div>
                        <div class="list-price">
                            订单金额：<span class="price-icon">¥</span> <span class="price-num">{{item.payAmount}}</span>
                        </div>
                        <div class="list-pay flex align-cen" v-if="item.orderStatus == 1">
                            <div class="mftbtn mft flex align-cen">
                                <div class="clsoebtn" @click="closeOrder(item)">取消订单</div>
                                 <div class="paybtn" @click="openPay(item)">支付</div>
                            </div>
                        </div>
                    </div>
                   </div>
                   </div>
                   <div v-else class="emty">
                        <i class="icon-al-wind-cry"></i>
                        <p>暂无订单</p>
                        <div class="btn" @click="openGo">返回</div>
                   </div>
                </div>
            </div>
        </div>
        <!-- 移动端订单列表 -->
        <div class="mobile-order-scne">
              <div class="mobile-order-notice-box">
                    <div class="order-notice-title">
                        <h2>企业订单</h2>
                    </div>
                    <div class="mobile-order-list" v-if="list.length">
                        <div class="row-list" v-for="(item, index) in list" :key="index">
                        <div class="list-header flex align-cen">
                        <span>订单号： {{item.id}}</span>
                        <span class="y-right mft">订单时间：{{item.createTime}}</span>
                    </div>
                     <div class="list-tab ">
                        <div class="coulm flex">
                              <div class="list-tab-left">
                              <div>订单类型</div>
                             <div>产品</div>
                             <div>订单主体</div>
                             <div>有效时间</div>
                              <div>订单来源</div>
                              <div>订单状态</div>
                        </div>
                        <div class="list-tab-right">
                             <div >{{item.orderType == 1 ? '应用订单' : '其他'}}</div>
                             <div>{{item.appName}}</div>
                             <div>{{item.businessName}}</div>
                             <div>{{item.deadline ? item.deadline + '月' : '无限期'}}</div>
                             <div>{{item.orderSource == 1 ? '官网' : '其他'}}</div>
                             <div>{{item.orderStatus == 0 ? '已取消' :  item.orderStatus == 1 ? '待支付' : '已完成'}}</div>
                        </div>
                        </div>
                        <div class="list-price">
                            订单金额：<span class="price-icon">¥</span> <span class="price-num">{{item.payAmount}}</span>
                        </div>
                          <div class="list-pay flex align-cen" v-if="item.orderStatus == 1">
                            <div class="mftbtn mft flex align-cen">
                                <div class="clsoebtn" @click="closeOrder(item)">取消订单</div>
                                 <div class="paybtn" @click="openPay(item)">支付</div>
                            </div>
                        </div>
                     </div>
                        </div>
                    </div>
                       <div v-else class="emty">
                        <i class="icon-al-wind-cry"></i>
                        <p>暂无订单</p>
                        <div class="btn" @click="openGo">返回</div>
                   </div>
              </div>
        </div>
    </div>
</template>
<script>
import LocaStorage from "../../utils/localstorage.js"
import { orderList,editOrder,enBusiness} from "@/api/enterprise/index" // 订单列表、取消订单
export default {
    name:'orderAdmin',
    data () {
        return {
            user:{},
            lotoken:'',
            list:[],
            bussID:''
        }
    },
     created(){
    document.title = "企业订单"
    const token1 = LocaStorage.setAge().get('token1')
    const userinfo1 = LocaStorage.setAge().get('userinfo1')
    const businessInfo = LocaStorage.setAge().get('businessInfo')
        this.user = userinfo1 
        this.lotoken = token1
        this.bussID = this.$route.query.businessId ? this.$route.query.businessId : businessInfo.id
        this.getInfo()
    },
    methods: {
             // 打开后台
        openMan(){
               // return this.$util.Notifi('加急开发中～','error','fa-exclamation-circle');
             enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                 if(res.data.length == 1){
                  localStorage.removeItem('businessInfo')
                 LocaStorage.setAge().set('businessInfo',res.data[0])
                const newurl = this.$router.resolve({path:'/webenterpriseManage/index', query: {}})
                 window.open(newurl.href,'_blank')
                }else{               
                 const newurl = this.$router.resolve({name:'enBusiness', query: {}})
                 window.open(newurl.href,'_blank')
                }
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                }
            })
        },
         // 打开设置
        openSet(){
            const newurl = this.$router.resolve({name:'enSetting', query: {}})
            window.open(newurl.href,'_blank')
        },
        // 返回上一层
        openGo(){
           this.$router.push('/webenterprise/homePage')
        },
        // 打开支付页面
        openPay(data){
            if(this.lotoken){
            this.$router.push({
                name:'buyOrder',
                query:{
                    id:data.id
                }
            })
            }else{
            this.$util.Notifi('token已过期','error','fa-exclamation-circle'); 
            this.$router.push({
            name:'enLogin',
            query: {
                id:this.$route.query.id,
                redirectUrl:'orderAdmin',
            }
         }) 
            }

        },
        // 取消订单
        closeOrder(data){
              this.$confirm('取消订单后，您需要重新下单购买服务？', '取消订单', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editorder(data)
                        }).catch(() => {          
                        });
        },
        editorder(row){
              editOrder({
                id:row.id,
                orderStatus:0,
                    },'put','enterprise')
                .then(res => {
                  if(res.code ==1){
                    this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                  }else{
                     this.$util.Notifi('订单取消成功','success','fa-check'); 
                    this.getInfo()
                  }
                })
                .catch(err => {
                })
        },
        // 订单列表
        getInfo(){
           
           orderList({
            id:this.bussID
           },'enterprise')
           .then(res => {
           this.list = res.data
           })
           .catch(err => {
            this.$router.push({
            name:'enLogin',
            query: {
                id:this.$route.query.id,
                redirectUrl:'orderAdmin',
            }
         })
           })
        }
    },
}
</script>
<style lang="scss" scoped>
.order{
    width: 100%;
    background: #f9f9f9;
    height: 100vh;
    .emty{
        text-align: center;
        padding-top: 250px;
        i{
            font-size: 50px;
        }
        .btn{
            color: #fff;
            padding: 5px 0px;
            border-radius: 5px;
            background: #ea3a3a;
            width: 100px;
            margin: 10px auto;
            cursor: pointer;
        }
    }
    .order-header{
    position: relative;
    background: #fff;
    height: 64px;
    position: relative;
   box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
      .header-container-left{
        line-height: 64px;
        height: 64px;
            margin-left: 24px;
             margin-right: 24px;
             img{
                width: 80px;
             }
     }
          .header-container-right{
        img{
                width: 30px;
            margin-right: 10px;
            border-radius: 50%;
            height: 30px;
        }
        .right-btn{
            height: 64px;
            margin-left: 24px;
             margin-right: 24px;
             color: #333;
             .right-login{
                margin-right: 24px;
                cursor: pointer;
             }
           .trial{
            padding: 10px 24px;
            
            color: #333;
            border-radius: 5px;
            cursor: pointer;
           } 
        }
     }
    }
    .mobile-order-scne{
        display: none;
    }
    .order-scne{
        .order-y-row{
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 12px;
            min-width: 1000px;
            max-width: 1200px;
            margin-left: auto;
            margin-right: auto;
            zoom: 1;
    .order-notice-box{
        padding: 0 40px;
        .order-notice-title{
            padding-top: 20px;
            h2{
            font-size: 14px;
            color: #373d41;
            font-weight: 700;
            position: relative;
            }
            h2::after{
                content: '';
                width: 60px;
                height: 2px;
                background: #155bd4;
                position: absolute;
                bottom: -10px;
                left: 0;
            }
        }
        .list-header{
         height: 30px;
        line-height: 30px;
        background: #f5f5f5;
        color: #9b9ea0;
        padding: 0 10px;
        margin: 30px 0 20px 0;
        }
        .list-tab{
            .list-tit {
                justify-content: space-around;
                border: 1px solid #EBEEF5;
                box-sizing: border-box;
                border-bottom: none;
                border-right: none;
                div{
                    
                    padding: 10px 0px;
                    text-align: center;
                    border-right: 1px solid #EBEEF5;
                }
            }
            .list-price{
                 border: 1px solid #EBEEF5;
                box-sizing: border-box;
                padding: 10px 30px;
                text-align: right;
                span{
                    color: #ea3a3a;
                }
              
                .price-num{
                    font-size: 24px;
                }
            }
            .list-tit1{
                background: #f5f5f5;
                
            }
            .list-pay{
                padding: 10px 30px;
                .mftbtn{
                    .clsoebtn{
                        margin-right: 10px;
                        cursor: pointer;
                    }
                    .paybtn{
                        padding: 3px 20px;
                        background:#ea3a3a;
                        color: #fff;
                        cursor: pointer;
                        border-radius: 5px;
                    }
                }
            }
        }
    }
        }
    }
}
::v-deep{
    .el-dropdown-link {
        color: #333 !important;
    }
}
@media (max-width: 640px){
.order-scne{
    display: none;
}
.order{
.mobile-order-scne{
    display: block;
    padding: 30px 10px;
      .order-notice-title{
            h2{
            font-size: 14px;
            color: #373d41;
            font-weight: 700;
            position: relative;
            }
            h2::after{
                content: '';
                width: 60px;
                height: 2px;
                background: #155bd4;
                position: absolute;
                bottom: -10px;
                left: 0;
            }
        }
        .mobile-order-list{
              .list-header{
        //  height: 30px;
        // line-height: 30px;
        background: #f5f5f5;
        color: #9b9ea0;
        padding: 5px 10px;
        margin: 30px 0 0px 0;
        font-size: 13px;
        }
        .list-tab{
            .list-tab-left{
                width: 30%;
                background: #f5f5f5;
                border: 1px solid #EBEEF5;
                box-sizing: border-box;
                border-bottom: none;
                border-right: none;
                div{
                    text-align: center;
                    padding: 10px 0px;
                     border-right: 1px solid #EBEEF5;
                      border-bottom : 1px solid #EBEEF5;
                }
            }
            .list-tab-right{
                width: 70%;
                border: 1px solid #EBEEF5;
                 border-bottom: none;
                border-left: none;
                div{
                    text-align: center;
                    padding: 10px 0px;
                    border-bottom : 1px solid #EBEEF5;
                }
            }
              .list-price{
                 border: 1px solid #EBEEF5;
                box-sizing: border-box;
                padding: 0px 30px;
                text-align: right;
                border-top:none;
                span{
                    color: #ea3a3a;
                }
              
                .price-num{
                    font-size: 24px;
                }
            }
             .list-pay{
                padding-top: 30px;
                .mftbtn{
                    .clsoebtn{
                        margin-right: 10px;
                        cursor: pointer;
                    }
                    .paybtn{
                        padding: 3px 20px;
                        background:#ea3a3a;
                        color: #fff;
                        cursor: pointer;
                        border-radius: 5px;
                    }
                }
            }
        }
        }
}
}
}
</style>